export function SiteSupport() {
  return (
    <>
      <section className="contact-section" id="contact" aria-labelledby="contact-title">
        <div>
          <p className="section-kicker">LET'S TALK</p>
          <h2 id="contact-title">Contact us.</h2>
          <p>Questions about your preview, payment or an existing link? We're here to help.</p>
        </div>
        <div className="contact-details">
          <svg viewBox="0 0 48 48" fill="none" aria-hidden="true"><rect x="5" y="10" width="38" height="28" rx="3"/><path d="m6 12 18 14 18-14M6 36l12-12M42 36 30 24"/></svg>
          <a className="contact-email" href="mailto:hallo@rupaworks.com">hallo@rupaworks.com <span aria-hidden="true">↗</span></a>
          <p>For preview or payment support, include your preview link or payment reference so we can find your export.</p>
          <a className="contact-account" href="https://rupaworks.com/account.html">View your previews <span aria-hidden="true">↗</span></a>
        </div>
      </section>
      <footer className="site-footer">
        <span>RupaPreview by Rupaworks. © 2026 PT RUPAWORKS.</span>
        <nav aria-label="RupaPreview support">
          <a href="/terms">Terms &amp; Privacy</a>
          <a href="https://seller.rupaworks.com/" target="_blank" rel="noreferrer">RupaSeller ↗</a>
        </nav>
      </footer>
    </>
  );
}
